import TomSelect from "tom-select";

class Form {
  constructor(formEl) {
    this.form = $(formEl);

    // this.form.find("select").each(function () {
    //   new TomSelect(this, {
    //     searchField: [],
    //   });
    // });

    this.form.on("submit", (e) => {
      e.preventDefault();

      this.form.addClass("loading");

      $(".error", this).removeClass("error");

      if (this.validate()) {
        setTimeout(() => {
          this.recaptcha();
        }, 500);
      } else {
        this.form.removeClass("loading");
      }
    });
    this.displayFilename();
    this.careerBtnHandler();
  }

  careerBtnHandler() {
    const btnWrapEl = $(".cform__btn-wrapper");
    if (!btnWrapEl.length) {
      return;
    }
    const buttons = btnWrapEl.find(".btn");

    buttons.on("click", function (e) {
      // Remove active class from all buttons
      buttons.removeClass("active");

      // Add active class to the clicked button
      $(this).addClass("active");
      $("#contact-type").val($(this).text());
    });
  }

  recaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        this.submit(token);
      });
    });
  }

  submit(token) {
    const formData = new FormData(this.form[0]);
    formData.append("token", token);

    this.form.find("button").addClass("loading");
    this.form.find(".form-status").addClass("hidden");

    const hasUploads = $(".file-upload");
    if (hasUploads.length) {
      let fileData = $(".file-upload")[0].files;
      $.each(fileData, function (index, file) {
        formData.append("file-" + index, file);
      });
    }

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          if (response.data.redirect) {
            window.location = response.data.redirect;
          } else {
            this.form[0].reset();

            this.form.find(".errors-wrap").remove();
            this.form.find(".form-status").removeClass("error");
            this.form
              .find(".cform__upload-placeholder.results")
              .addClass("hidden");
          }
        } else {
          this.form.find(".form-status").addClass("error");
        }

        this.form
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        this.form.removeClass("loading");
        this.form.find("button").removeClass("loading");
      });
  }

  is_valid_email(email) {
    let pattern = new RegExp(
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
    );
    return pattern.test(email);
  }

  validate() {
    const form = this.form;
    let errors = {};

    const fields = form.find(".required").not(".disabled");

    // Check if all required fields are filled
    for (let i = 0; i < fields.length; i++) {
      const input = $(fields[i]);
      let error = false;
      const name = input.attr("name");

      // Check field type
      switch (input.attr("type")) {
        // Email
        case "email":
          if (!input.val() || !this.is_valid_email(input.val())) {
            error = true;
            errors[name] = translations.valid_email;
          }
          break;

        // Checkbox, radio
        case "checkbox":
        case "radio":
          if (!input.prop("checked")) {
            error = true;
            errors[name] = translations.valid_check;
          }
          break;

        // Text, textarea
        default:
          if (!input.val()) {
            error = true;
            errors[name] =
              // translations.required
              // + " " +
              input.data("error-msg");
          }
      }

      // Handle error class
      if (error) {
        input.parent().addClass("error");
        input.siblings(".field__error").text(errors[name]);
      } else {
        input.parent().removeClass("error");
        input.siblings(".field__error").addClass("hidden");
      }
    }

    // Handle persons selection
    if ($(".formPerson").length) {
      const persons = $(".formPerson input[type='radio']");
      let isChecked = false;

      // Check if at least one checkbox is checked
      persons.each(function () {
        if ($(this).prop("checked")) {
          isChecked = true;
          return false;
        }
      });

      // If none are checked, set an error
      if (!isChecked) {
        errors["person_selection"] = translations.valid_check;
        $(".formPerson").addClass("error");
      } else {
        delete errors["person_selection"];
        $(".formPerson").removeClass("error");
      }
    }

    return !Object.keys(errors).length;
  }
  displayFilename() {
    const self = this;

    var uploadedFileNames = [];

    // Attach event handler to dynamically added file input elements
    $(document).on("change", ".file-upload", function () {
      uploadedFileNames = [];
      var files = $(this)[0].files;

      for (var i = 0; i < files.length; i++) {
        uploadedFileNames.push(files[i].name);
      }

      // Call the updateFileList method using the 'self' reference
      self.updateFileList(uploadedFileNames);
    });
  }

  updateFileList(uploadedFileNames) {
    const resultEl = $(".cform__upload-placeholder.results");
    let fileNameEl = resultEl.find("p");

    resultEl.removeClass("hidden");

    if (uploadedFileNames.length > 0) {
      for (var i = 0; i < uploadedFileNames.length; i++) {
        var fileName = uploadedFileNames[i];
        var fileSpan = $('<p class="form__filename">').text(fileName);
        $(resultEl).append(fileSpan);
      }
    }
  }
}

export default Form;
